import { Redirect } from "react-router-dom";

import { useGetTradingAccount } from "~/v2/api/hooks";
import { useAdvancedTradingDashboardAccess } from "~/v2/helpers/featureFlags";
import { Path } from "~/v2/path";

export default function RootRedirect() {
  const { account } = useGetTradingAccount();
  const advancedTradingDashboardAccess = useAdvancedTradingDashboardAccess();

  if (account) {
    switch (account.status) {
      case "PAPER_ONLY":
      case "ONBOARDING":
        return <Redirect to={Path.ROUTE_NEW_ACCOUNT} />;
      default:
        if (
          advancedTradingDashboardAccess === "pending" ||
          advancedTradingDashboardAccess === "unavailable"
        ) {
          return null;
        }
        return (
          <Redirect
            to={
              advancedTradingDashboardAccess === "allowed"
                ? Path.ROUTE_PRO
                : Path.ROUTE_DASHBOARD
            }
          />
        );
    }
  }

  return null;
}
